/* eslint-disable @typescript-eslint/no-empty-object-type, @typescript-eslint/no-empty-interface */
/** WARNING: This file is generated automatically **/

import type { TrackingContextValue } from '../providers/TrackingContext';
import { getEntities } from '../utils/getEntities';
import { getGTMData } from '../utils/getGTMData';
import { trackSelfDescribingEvent } from '../utils/trackSelfDescribingEvent';

/**
 * triggers when crm zone is loaded and presented to the user
 */
export interface CrmZoneView {}

export const crmZoneView = (data: Readonly<CrmZoneView>, context?: TrackingContextValue) => {
  window.__GTM_DATA_LAYER__?.push({ event: 'crm_zone_view', ...data, ...getGTMData(context) });

  trackSelfDescribingEvent(
    {
      event: {
        schema: 'iglu:com.starsgroup/crm_zone_view/jsonschema/1-0-0',
        data
      },
      context: getEntities(context)
    },
    context
  );
};
